import { RootState } from '../../../types.ts';

export const selectUnitRates = (state: RootState) => state.unitRates;

export const selectRegression = (state: RootState) => state.unitRates.regression;

export const selectSensitivityAnalysis = (state: RootState) => state.unitRates.sensitivityAnalysis;
